export const formatTotal = (total: number) => {
    const formattedTotal = total.toString().replace(".", ",");
    return formattedTotal;
}
